
import React, { useLayoutEffect, useState,useEffect } from 'react';
import axios from "axios";
import 'devextreme/data/odata/store';
import "./map.css";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Filezone,{ Filezonefile } from './Filezone';
import PropertyBuildingsPreview from './PropertyBuildingsPreview';
import { useLocation } from "react-router-dom";
import {API_BASE_URL} from '../../../../config';
// import { getApiBaseUrl } from '../../../../config';
import GalleryModal from "./GalleryModal";
import MapModal from "./MapModal";

import { Modal, Button } from "react-bootstrap";
import Gallery from 'devextreme-react/gallery';
import DataGrid, {
    Column,
    Pager,
    Paging,
    SearchPanel,
    Export,
    Lookup, 
    ColumnFixing,
    Editing} from 'devextreme-react/data-grid';
import { EmptyItem} from 'devextreme-react/form';
//import { jsPDF } from 'jspdf';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import Geocode from "react-geocode";
import MapContainer from "./Map"
import { useHistory } from "react-router-dom";

import Swal from 'sweetalert2';
//import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid } from 'devextreme/excel_exporter';


const PropertyList = () => {
    const history = useHistory();
    const locations = useLocation();

    const [dataList, setdataList] = useState([]);
    const [prID, setPrID] = useState("");
    const [modalShow, setModalShow] = useState(false);
    const [mapModal, setMapModal] = useState(false);
    const [location, setLocation] = useState({lat:53.9171, lng:122.74, name:'My Location'})
    var lat=53.9171, lng=122.74;
    
    const modClose = () => setModalShow(false);
    const [imgShow, setImgShow] = useState(false);     
    const imgmodClose = () => setImgShow(false);
    
    const [dropShow, setDropShow] = useState(false);     
    const dropClose = () => setDropShow(false);

    const getUploadParams = ({ file, meta }) => {
        const body = new FormData()
        body.append('file', file)
        body.append('propertyid',prID)
        return { url: `${API_BASE_URL}api/primgupload`, body }
    }


    const getUploadFiles = ({ file, meta }) => {
        const body = new FormData()
        body.append('file', file)
        body.append('propertyid',prID)
        return { url: `${API_BASE_URL}api/prfileupload`, body }
    }
    



    const [imgGallery, setGallery] = useState([]);  
    const [galleryTitle, setGalleryTitle] = useState([]);
    
    const [expandImg, setExpandImg] = useState(""); 
    const [expandShow, setExpandShow] = useState('none'); 
    const expandClose = () => setExpandShow('none');
    useEffect(() => {
        if (locations.state?.openPropertyId) {
        // fetch property details by ID
        fetch(`${API_BASE_URL}api/property/${locations.state.openPropertyId}`)
            .then((res) => res.json())
            .then((data) => {
            setDetail(data);
            setModalShow(true);
            })
            .catch(console.error);
        }
    }, [locations.state]);
    useEffect(() => {
    if (modalShow && locations.state?.openSection === "buildings") {
        setTimeout(() => {
        document
            .getElementById("buildings-section")
            ?.scrollIntoView({ behavior: "smooth" });
        }, 300);
    }
    }, [modalShow, locations.state]);


    const getImg = (data) => {
        fetch(`${API_BASE_URL}api/property/`+data)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                setGalleryTitle(res.propertyaddress)                
                
                if(res.image==null){                    
                    setGallery([])
                    console.log("fail map")
                }else{
                    const imgage =res.image.split(',') 
                    
                    console.log(imgage)
                    setGallery(imgage)
                }
                
            });
        setImgShow(true)      

    };
    
    const [infoDetail, setDetail] = useState([]);
    // setDetail(infoLease)

    const getInfo = (data) => {
        console.log(data)
        setDetail(data)
        setModalShow(true)        

    };

    const exportFormats = ['xlsx'];

    useLayoutEffect(() => {
        console.log('Test');
        axios.get(`${API_BASE_URL}api/propertylist`).then(resp => {
            if (resp.status === 200) {
                // resp.data.forEach((itm) => {
                //     itm.leasetype = leaseTypes.filter(v => v.value === itm.leasetype)[0].name
                //     //itm.commdate = itm.comdate ? intl.parseDate(itm.comdate) : null 
                //     //itm.expdate = itm.expdate ? intl.parseDate(itm.expdate) : null
                //     itm.address1 = `${itm.address1} ${itm.address2} ${itm.city} ${itm.state} ${itm.zip ? itm.zip : ''}`
                // })
                setdataList(resp.data)
                //setDataResult(resp.data, dataState);
            }
        })
    }, [])



    
    
    
    const onRowInserting = (e) => {
        return axios.put(`${API_BASE_URL}api/propertyadd`, e.data)
            .then(() => axios.get(`${API_BASE_URL}api/propertylist`))
            .then(resp => {
                setdataList(resp.data);

                // ✅ Show success alert
                Swal.fire(
                'Done',
                'Property added Successfully!',
                'success'
                );
            })
            .catch(err => {
            Swal.fire('Unable to add', 'Something went wrong.', 'warning');
            e.cancel = true;
            });
    };

    const onRowUpdating = (e) => {
        return axios.put(`${API_BASE_URL}api/propertygrid`, {
            propertyid: e.key,
            values: e.newData
        })
            .then(() => axios.get(`${API_BASE_URL}api/propertylist`))
            .then(resp => setdataList(resp.data))
            .catch(err => {
            Swal.fire('Unable to update', 'Something went wrong.', 'warning');
            e.cancel = true;
            });
    };

    const onRowRemoving = (e) => {
         // cancel default optimistic delete
        e.cancel = true;
        return axios.put(`${API_BASE_URL}api/propdel`, { propertyid: e.data.propertyid })
            .then(() => axios.get(`${API_BASE_URL}api/propertylist`))
            .then(resp => setdataList(resp.data))
            .catch(err => {
            Swal.fire(
                'Unable to delete',
                err?.response?.data?.message || "The property can't be deleted.",
                'warning'
            );
            // e.cancel = true; // ✅ row stays in grid if delete fails
            });
    };
    const onRowClick = ((e) => {
        // console.log(e.data);
        getInfo(e.data)
    });
    
    const optionYesNo = [{
        ID: 'Y',
        Name: 'Yes',
      }, {
        ID: 'N',
        Name: 'No',
      }]

    const onExporting = ((e) => {
        if (e.format === 'xlsx') {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Data');
            exportDataGrid({
                component: e.component,
                worksheet,
                autoFilterEnabled: true,
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'PropertyData.xlsx');
                });
            });
        }
        // const doc = new jsPDF();
        else if (e.format === 'pdf') {
            // exportDataGridToPdf({
            //     jsPDFDocument: doc,
            //     component: e.component
            // }).then(() => {
            //     doc.save('Companies.pdf');
            // })
        };
    });


    return(
        <div>
            <div>

<React.Fragment>

            <DataGrid
                keyExpr="propertyid"
                className={'dx-card wide-card'}
                dataSource={dataList}
                showRowLines={false}
                showBorders={true}
                columnAutoWidth={true}
                onRowClick={onRowClick}
                allowColumnReordering={true}
                rowAlternationEnabled={true}
                onRowInserting={onRowInserting}
                onRowUpdating={onRowUpdating}
                onRowRemoving={onRowRemoving}
                
                onExporting={onExporting}>
                <Editing mode="popup" allowAdding="true"  allowUpdating={true} allowDeleting={true} />
                <ColumnFixing enabled={true} />
                <Paging defaultPageSize={25} />
                <Pager showPageSizeSelector={true} showInfo={true} allowedPageSizes={[5, 10, 25, 50, 100, 'all']} />
                <Export enabled={true} formats={exportFormats} />
                <SearchPanel visible={true} highlightCaseSensitive={true} />                
                <Column caption={'Map View'} dataType={String} formItem={{visible:false}}  cellRender={(data)=>{
                    let addrs = data.data.propertyaddress;
                    if(data.data.city){
                        addrs =addrs+','+data.data.city;
                    }
                    if(data.data.state){
                        addrs =addrs+','+data.data.state;
                    }
                    return (<><a href="#" onClick={()=>{  
                        getImg(data.data.propertyid) 
                    }
                    }>
                    <svg viewBox="0 0 24 24" fill="none" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5 14.2864C3.14864 15.1031 2 16.2412 2 17.5C2 19.9853 6.47715 22 12 22C17.5228 22 22 19.9853 22 17.5C22 16.2412 20.8514 15.1031 19 14.2864M18 8C18 12.0637 13.5 14 12 17C10.5 14 6 12.0637 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8Z" stroke="#780707" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </a>&nbsp;&nbsp;<a href="#" onClick={()=>{
                        Geocode.setApiKey("AIzaSyBxLd_UmZ_U0NLhQvqTLd-Ek_k3SbOkykI")
                        Geocode.setLanguage("en");
                        Geocode.setLocationType("ROOFTOP");
                        console.log("geocode")
                        Geocode.fromAddress(addrs).then(
                        (response) => {
                            console.log(response.results[0].geometry.location)
                            lat = response.results[0].geometry.location.lat;
                            lng = response.results[0].geometry.location.lng
                            setLocation({lat:lat, lng:lng, name: data.value});
                            console.log(`Lat:${lat}Lng:${lng}`)
                        })
                        setMapModal(true)
                        }
                        }><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"  color='orange' fill='orange' viewBox="0 0 24 24">
                        <path d="M20.5 3l-0.16 0.030-5.34 2.070-6-2.1-5.64 1.9c-0.21 0.070-0.36 0.25-0.36 0.48v15.12c0 0.28 0.22 0.5 0.5 0.5l0.16-0.030 5.34-2.070 6 2.1 5.64-1.9c0.21-0.070 0.36-0.25 0.36-0.48v-15.12c0-0.28-0.22-0.5-0.5-0.5zM15 19l-6-2.11v-11.89l6 2.11v11.89z"></path>
                        </svg></a></>)
                    
                }}/>
                <Column dataField={'pid'} caption={'Property ID/Tax ID'} cellRender={(data) => {
                    return(<>
                    <div>{(data.data.prand == 1 ?
                    <b style={{color:"#C42929"}}>{data.value}</b>:                  
                    <div >{data.value}</div>
                    )}</div></>)
                }} />
                                   
                
                <Column dataField={'areasf'} caption={'Property Sq Ft'} dataType={Number} format={'#,###'} />
                <Column dataField={'acres'} caption={'Property Acres'} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                <Column dataField={'mapno'} caption={'Map'} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                <Column dataField={'mapgrid'} caption={'Map Grid'} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                <Column dataField={'parcel'} caption={'Parcel'} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                <Column dataField={'LIDRE'} caption={'LIDRE'} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                <Column dataField={'propertyaddress'} caption={'Address'} validationRules={[{ type: "required", message: "Address is required" }]} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                <Column dataField={'city'} caption={'City'} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                <Column dataField={'state'} caption={'State'} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                <Column dataField={'zip'} caption={'ZIP+4'} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                            
                <Column dataField={'disposeflag'} caption={'Disposed'} >
                    <Lookup dataSource={optionYesNo} valueExpr="ID" displayExpr="Name" />
                </Column>
                <Column dataField={'disposeddate'} caption={'Disposed Date'} dataType={'date'} format={'MM/dd/yyyy'}  />
                                
                <Column width={40} allowEditing={false} editCellRender={()=>{ return (<><input type="hidden" /></>)}}  fixed={true} fixedPosition="right" cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ 
                    setDropShow(true) 
                    setPrID(data.data.propertyid) } } className="" title="Upload" aria-label="Upload" >
                    <svg width="24" height="24" viewBox="0 0 24.00 24.00" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.8"> <path opacity="0.5" d="M3 15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15" stroke="#26975A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 16V3M12 3L16 7.375M12 3L8 7.375" stroke="#26975A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g><g id="SVGRepo_iconCarrier"> <path opacity="0.5" d="M3 15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15" stroke="#26975A" stroke-width="1.752" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 16V3M12 3L16 7.375M12 3L8 7.375" stroke="#26975A" stroke-width="1.752" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </a></>)}} />
            </DataGrid>


            <GalleryModal
                show={imgShow}
                onHide={imgmodClose}
                title={galleryTitle}
                images={imgGallery}
                onExpand={(img) => {
                    setExpandImg(img);
                    setExpandShow("block");
                }}
                />


            <Modal size="lg"  show={dropShow} onHide={dropClose} aria-labelledby="contained-modal-vcenter" centered >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-vcenter">Upload Imgages /Files  {galleryTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className='loderdiv'>
                    <div className='file-header-label'>Add Property Image (Map Snapshots):</div>
                    <div className='file-image-zone' style={{minHeight:"300px", width:"80%" ,margin:'auto'}}>
                        <Dropzone
                            getUploadParams={getUploadParams}
                            accept="image/*"
                            inputContent={Filezone}
                            />
                    </div>
                    <div className='file-header-label'>Add Property Files (Documents) :</div>
                    <div className='file-doc-zone' style={{minHeight:"200px", width:"80%" ,margin:'auto'}}>
                        <Dropzone
                            getUploadParams={getUploadFiles}
                            accept="*"
                            inputContent={Filezonefile}
                            
                            />
                    </div>
                </div>
                </Modal.Body>
            </Modal>


            <Modal
            dialogClassName="modal-90w"
            show={modalShow} onHide={modClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                Property Details
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div style={{width:'100%'}}>
                <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                                

                            <Grid item xs={12} md={12}>
                                <div>
                                    <div className='info-title'>Property Information</div>
                                    <div className='info-details'>
                                    <Grid container spacing={2}> 
                                            <Grid item xs={12} md={3}>
                                                <div className='info-record-label'>Property ID</div>
                                                <div className='info-record-value'>{(infoDetail.prand==1?<b style={{color:"#C42929"}}>{infoDetail.pid}</b>:<>{infoDetail.pid}</>)}</div>
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <div className='info-record-label'>Property Sq Ft</div>
                                                <div className='info-record-value'>{infoDetail.areasf}</div>
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <div className='info-record-label'>Property Acres</div>
                                                <div className='info-record-value'>{infoDetail.acres}</div>
                                            </Grid>
                                            
                                            <Grid item xs={12} md={3}>
                                                <div className='info-record-label'>Map</div>
                                                <div className='info-record-value'>{infoDetail.mapno}</div>
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <div className='info-record-label'>Map Grid</div>
                                                <div className='info-record-value'>{infoDetail.mapgrid}</div>
                                            </Grid>

                                            <Grid item xs={12} md={3}>
                                                <div className='info-record-label'>Parcel</div>
                                                <div className='info-record-value'>{infoDetail.parcel}</div>
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <div className='info-record-label'>LIDRE</div>
                                                <div className='info-record-value'>{infoDetail.LIDRE}</div>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                            </Grid>

                                        </Grid>
                                        
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                    <div>
                                        <div className='info-title'>Location Details</div>
                                        <div className='info-details'>
                                            <Grid container spacing={2}>                                               

                                                                    
                                                    <Grid item xs={12} md={3}>
                                                        <div className='info-record-label'>Address</div>
                                                        <div className='info-record-value'>{infoDetail.propertyaddress}</div>
                                                    </Grid>
                                                    <Grid item xs={12} md={3}>
                                                        <div className='info-record-label'>City</div>
                                                        <div className='info-record-value'>{infoDetail.city}</div>
                                                    </Grid>
                                                    <Grid item xs={12} md={3}>
                                                        <div className='info-record-label'>State</div>
                                                        <div className='info-record-value'>{infoDetail.state}</div>
                                                    </Grid>
                                                    <Grid item xs={12} md={3}>
                                                        <div className='info-record-label'>Zip+4</div>
                                                        <div className='info-record-value'>{infoDetail.zip}</div>
                                                    </Grid>
                                            
                                                
                                            </Grid>
                                            
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} id="buildings-section">
                                    <div>
                                        <div className='info-title'>Buildings</div>
                                        <div className='info-details'>
                                        <PropertyBuildingsPreview
                                        propertyId={infoDetail.propertyid}
                                        onManageBuildings={(id) => history.push(`/buildings/${id}`)}
                                        />
                                        </div>
                                    </div>
                                </Grid>

                            </Grid>
                </Box>
            </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={modClose}>Close</Button>
            </Modal.Footer>
            </Modal>

            <MapModal
                show={mapModal}
                onHide={() => setMapModal(false)}
                location={location}
                />


            <div className="expandView" style={{display: expandShow}}>
                <a className="expandCl" onClick={expandClose}>&times;</a>
                <div className="expandImg">
                    <img  src={expandImg} alt="Exapnd Image" />
                </div>

            </div>

        </React.Fragment>                
                </div>
                </div>
    )

}

export default PropertyList;